import styled from 'styled-components';
import { variables, devices } from '../../assets/styles/variables';

/**
 * Inline error shown when a form submission fails.
 *
 * Deliberately not the existing `.invalid-label` class: that one is `position: absolute`
 * (it floats above an input) and it lives in a stylesheet that is only pulled in by the
 * contract/provider forms, so it is not guaranteed to be bundled on every page a form renders on.
 */
const FormError = styled.p`
  margin: 0;
  color: #d0021b;
  font-family: ${variables.fontFamilyPrimary};
  font-size: 16px;
  line-height: 1.35;
  font-weight: 500;
  text-align: center;

  @media (max-width: ${devices.sizeTablet}) {
    font-size: 15px;
  }
`;

export default FormError;
